import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EStickyButtonActionTypes {
  Show = 'StickyButton/Show',
  Hide = 'StickyButton/Hide',
}

export type TShowStickyButton = ITypedReduxAction<EStickyButtonActionTypes.Show>;

export const showStickyButton: () => TShowStickyButton = actionGenerator<EStickyButtonActionTypes.Show>(
  EStickyButtonActionTypes.Show,
);

export type THideStickyButton = ITypedReduxAction<EStickyButtonActionTypes.Hide>;

export const hideStickyButton: () => THideStickyButton = actionGenerator<EStickyButtonActionTypes.Hide>(
  EStickyButtonActionTypes.Hide,
);

export type TStickyButtonActionTypes = TShowStickyButton | THideStickyButton;
